import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";
import { fadeUp } from "@/lib/site";

const ITEMS = [
  { top: "Meta Business", big: "PARTNER", sub: "Verificirani partner" },
  { top: "Ekskluzivno", big: "10", sub: "klijenata godišnje" },
  { top: "Cijena po upitu", big: "1–20 €", sub: "ovisno o vrijednosti usluge" },
];

export default function TrustBar() {
  return (
    <section className="relative z-10 border-y border-[#222] bg-[#0a0a0a]">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 md:grid-cols-3">
        {ITEMS.map((it, i) => (
          <motion.div
            key={i}
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            custom={i}
            className={`flex flex-col items-center gap-2 px-6 py-12 text-center md:py-16 ${
              i < ITEMS.length - 1 ? "border-b border-[#222] md:border-b-0 md:border-r" : ""
            }`}
          >
            <span className="flex items-center gap-2 font-display text-[0.7rem] font-bold uppercase tracking-[0.2em] text-[#50C878]">
              {i === 0 && <BadgeCheck size={14} />}
              {it.top}
            </span>
            <span className="font-display text-4xl font-black uppercase tracking-tight text-white md:text-5xl">
              {it.big}
            </span>
            <span className="text-sm text-white/50">{it.sub}</span>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
